core.service('fileHelper', ['$q',
    function ($q) {

        this.getMD5 = function (file) {
            var deffered = $q.defer();

            var reader = new FileReader();
            var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
            var spark = new SparkMD5.ArrayBuffer();
            var chunkSize = 1024*1024*2;
            var chunks = Math.ceil(file.size / chunkSize);
            var currentChunk = 0;

            reader.onload = function (e) {
                spark.append(e.target.result);
                currentChunk++;

                if (currentChunk < chunks) {
                    loadNext();
                } else {
                    deffered.resolve(spark.end());
                }
            };

            reader.onerror = function (e) {
                console.warn('oops, something went wrong.');
                deffered.reject(e);
            };

            function loadNext() {
                var start = currentChunk * chunkSize,
                    end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

                reader.readAsArrayBuffer(blobSlice.call(file, start, end));
            }

            loadNext();

            return deffered.promise;
        };

        this.getFileFormData = function (enclosedFile, token, md5sum, eventObjectType) {
            var formData = new FormData();
            formData.append('file', enclosedFile);
            formData.append('fileName', enclosedFile.name);
            formData.append('selectedFileSize', enclosedFile.size);
            formData.append('token', token);
            formData.append('hostFrom', 'MDX');
            formData.append('uploadType', eventObjectType);
            formData.append('md5hash', md5sum);
            return formData;
        }
    }]
);